import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export const dependenciesTimelineSearch = createSlice({
  name: 'dependenciesTimelineSearch',
  initialState: '',
  reducers: {set: (_, action: PayloadAction<string>) => action.payload},
})
